import { render, staticRenderFns } from "./replacementPerformanceComparison.vue?vue&type=template&id=eb0c3380&scoped=true"
import script from "./replacementPerformanceComparison.vue?vue&type=script&lang=js"
export * from "./replacementPerformanceComparison.vue?vue&type=script&lang=js"
import style0 from "./replacementPerformanceComparison.vue?vue&type=style&index=0&id=eb0c3380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0c3380",
  null
  
)

export default component.exports